// eslint-disable-next-line no-unused-vars
import SubBubbleAgreementViewModel from '@/models/subBubbleAgreement/subBubbleAgreementViewModel'
// eslint-disable-next-line no-unused-vars
import ClientPayClassClassificationViewModel from '@/models/client/clientPayClassClassificationViewModel'
import { ModelApiService } from './BaseApiService'

export default class ClientApiService extends ModelApiService {
  constructor() {
    super('client-group')
  }

  /**
   * Retrieves a list of sub bubble agreements for a client group
   * @returns {Promise<SubBubbleAgreementViewModel[]>}
   */
  async getSubBubbleAgreements(clientGroupId) {
    return await this.get(`${clientGroupId}/sub-bubble-agreements`)
  }

  /**
   * Retrieves a list of pay class classifications for Client Group
   * @returns {Promise<ClientPayClassClassificationViewModel[]>}
   */
  async getPayClassClassifications(clientGroupId) {
    return await this.get(`${clientGroupId}/pay-class-classifications`)
  }
}
